import { ReactNode, useEffect, useMemo, useState } from "react";

interface SequentialHighlightProps {
  children: ReactNode;   // ✅ accept single or multiple
  delay?: number;        // ms between items
  duration?: number;     // highlight duration
}

const SequentialHighlight = ({
  children,
  delay = 700,
  duration = 900,
}: SequentialHighlightProps) => {
  const items = useMemo(
    () => (Array.isArray(children) ? children : [children]),
    [children]
  );

  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  useEffect(() => {
    if (!items.length) return;

    const timers: number[] = [];

    items.forEach((_, index) => {
      const start = window.setTimeout(() => {
        setActiveIndex(index);

        const end = window.setTimeout(() => {
          setActiveIndex(null);
        }, duration);

        timers.push(end);
      }, index * delay);

      timers.push(start);
    });

    return () => timers.forEach(clearTimeout);
  }, [items.length, delay, duration]);

  return (
    <>
      {items.map((child, index) => (
        <span
          key={index}
          className={`seq-wrapper ${
            activeIndex === index ? "seq-highlight" : ""
          }`}
        >
          {child}
        </span>
      ))}
    </>
  );
};

export default SequentialHighlight;
